import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IResponse } from '~/types/repositories';
import type { IAPICartResponseData, ICartAddParams } from '~/modules/cart/types/cart-types';
import type { IQuantity } from '~/modules/catalog/types/product';

export default class Cart extends AbstractFetch {
  private static readonly CART = 'v1/cart/';
  private static readonly ADD = 'v1/cart/';
  private static readonly REMOVE = 'v1/cart/';
  private static readonly COUNT = 'v1/cart/count/';
  private static readonly SET_QUANTITY = 'v1/cart/setQuantity/';
  private static readonly CHANGE_OFFER = 'v1/cart/changeOffer/';
  private static readonly CLEAR = 'v1/cart/clear/';
  private static readonly CLEAR_NOT_AVAILABLE = 'v1/cart/clearNotAvailable/';
  private static readonly BULK = 'v1/cart/bulk/';
  private static readonly SET_PROMO_CODE = 'v1/cart/setPromoCode/';

  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  async getCart(): Promise<IResponse<IAPICartResponseData>> {
    return this.fetch(Cart.CART);
  }

  async addToCart({ productId, quantity, offerId, services, relatedLineId, metadata }: ICartAddParams): Promise<IResponse<any>> {
    return this.fetch(Cart.ADD, {
      method: 'POST',
      body: {
        product_id: productId,
        quantity,
        offer_id: offerId,
        services,
        related_line_id: relatedLineId,
        metadata,
      },
    });
  }

  async getCount(): Promise<IResponse<IQuantity>> {
    return this.fetch(Cart.COUNT);
  }

  async remove(params: { lineId: string | number }): Promise<IResponse<void>> {
    return this.fetch(Cart.REMOVE, {
      method: 'DELETE',
      body: {
        line_id: params.lineId,
      },
    });
  }

  async setQuantity(params: { lineId: string | number; quantity: number }): Promise<IResponse<void>> {
    return this.fetch(Cart.SET_QUANTITY, {
      method: 'POST',
      body: {
        line_id: params.lineId,
        quantity: params.quantity,
      },
    });
  }

  async changeOffer(params: { lineId: string | number; offerId: number }): Promise<IResponse<void>> {
    return this.fetch(Cart.CHANGE_OFFER, {
      method: 'POST',
      body: {
        line_id: params.lineId,
        offer_id: params.offerId,
      },
    });
  }

  async clear(): Promise<IResponse<void>> {
    return this.fetch<IResponse<void>>(Cart.CLEAR, {
      method: 'POST',
    });
  }

  async clearNotAvailable(): Promise<IResponse<void>> {
    return this.fetch<IResponse<void>>(Cart.CLEAR_NOT_AVAILABLE, {
      method: 'POST',
    });
  };

  async bulk(lines: any): Promise<IResponse<void>> {
    return this.fetch<IResponse<void>>(Cart.BULK, {
      method: 'POST',
      body: {
        items: lines,
      },
    });
  };

  async setPromocode(code: string): Promise<IResponse<void>> {
    return this.fetch(Cart.SET_PROMO_CODE, {
      method: 'POST',
      body: {
        code,
      },
    });
  }
}
